/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  migrateInbox(sourceInboxId, targetInboxId, deleteSource = false) {
    return axios.post(`${this.url}/${sourceInboxId}/migrate`, {
      target_inbox_id: targetInboxId,
      delete_source: deleteSource,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  // Valor completo de um segredo do canal (a lista de caixas só traz mascarado). Só admin.
  getSecret(inboxId, field) {
    return axios.get(`${this.url}/${inboxId}/secret`, { params: { field } });
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  getAiAgentPriorities(inboxId) {
    return axios.get(`${this.url}/${inboxId}/ai_agent_priorities`);
  }

  // priorities: [{ agent_id, priority }]
  updateAiAgentPriorities(inboxId, priorities) {
    return axios.patch(`${this.url}/${inboxId}/ai_agent_priorities`, {
      priorities,
    });
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  replicateBusinessHours(inboxId, { scope, inboxIds = [] }) {
    return axios.post(`${this.url}/${inboxId}/replicate_business_hours`, {
      scope,
      inbox_ids: inboxIds,
    });
  }

  // UazAPI methods
  getUazapiStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/uazapi_status`);
  }

  connectUazapi(inboxId) {
    return axios.post(`${this.url}/${inboxId}/uazapi_connect`);
  }

  disconnectUazapi(inboxId) {
    return axios.post(`${this.url}/${inboxId}/uazapi_disconnect`);
  }

  reconfigureUazapi(inboxId) {
    return axios.post(`${this.url}/${inboxId}/uazapi_reconfigure`);
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  createMessageTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/message_templates`, {
      template,
    });
  }

  getMessageTemplates(inboxId) {
    return axios.get(`${this.url}/${inboxId}/message_templates`);
  }

  // templateId here is the template's numeric Meta ID.
  updateMessageTemplate(inboxId, templateId, template) {
    return axios.patch(
      `${this.url}/${inboxId}/message_templates/${templateId}`,
      {
        template,
      }
    );
  }

  // templateName here is the template's name (Meta deletes templates by name).
  deleteMessageTemplate(inboxId, templateName) {
    return axios.delete(
      `${this.url}/${inboxId}/message_templates/${templateName}`
    );
  }

  // Flows published on the WABA, for the FLOW button picker.
  getTemplateFlows(inboxId) {
    return axios.get(`${this.url}/${inboxId}/message_templates/flows`);
  }

  // Cria e publica um Flow a partir de um modelo pronto do catálogo.
  createTemplateFlow(inboxId, payload) {
    return axios.post(
      `${this.url}/${inboxId}/message_templates/flows`,
      payload
    );
  }

  uploadTemplateMedia(inboxId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(
      `${this.url}/${inboxId}/message_templates/media_upload`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }
}

export default new Inboxes();
